module.exports = __webpack_public_path__ + "static/media/file-fill.8cba54e8.svg";